import { render, staticRenderFns } from "./PeriodPurchases.vue?vue&type=template&id=3cae41ba&scoped=true&"
import script from "./PeriodPurchases.vue?vue&type=script&lang=ts&"
export * from "./PeriodPurchases.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodPurchases.vue?vue&type=style&index=0&id=3cae41ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae41ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
